import React from "react";
import { GradientTypo } from "../../header/Header";
import { Box } from "@mui/material";
import useOdyssee from "../../../context/odyssee/useOdyssee";
import MenuOdyssee from "./MenuOdyssee";
import Home from "./Home";
import Summary from "./summary";
import { motion } from "motion/react";
import { useIsMobile } from "../../../hooks/responsive";
import GoFurther from "./GoFurther";
import { useGetOdysseeGoFurtherQuery, useGetListWebinairesQuery } from "../../../store/api/odyssee";
import { useAuthToken } from "../../../hooks/auth";
import Community from "./Community";
import OdysseeCommunityStat from "../OdysseeCommunityStat";

const MENU_ELEMENTS = [
	{ name: "Mon odyssée", id: 0, disabled: false },
	{ name: "Mes étapes", id: 1, disabled: false },
	{ name: "Webinaires", id: 2, disabled: false },
	{ name: "Aller plus loin", id: 3, disabled: true },
];

const OdysseeHome = () => {
	const [currentPage, setCurrentPage] = React.useState(0);
	const [isInLive, setisInLive] = React.useState(false);
	const isMobile = useIsMobile();
	const { odyssee } = useOdyssee();
	const authToken = useAuthToken();
	const menuRef = React.useRef(null);

	const { data: goFurther } = useGetOdysseeGoFurtherQuery(
		{ odysseeId: odyssee?.id, authToken },
		{ skip: !authToken || !odyssee }
	);

	const { data } = useGetListWebinairesQuery(
		{ odysseeId: odyssee?.id, authToken },
		{ skip: !authToken || !odyssee }
	);

	React.useEffect(() => {
		if(data) {
			const futures = data?.futures || [];
			if(Array.isArray(futures) && futures.findIndex((elemnt) => elemnt.status === "online") >= 0) {
				setisInLive(true)
			}
		}
	}, [data])
	

	const menuElement = React.useMemo(() => {
		return [
			{ name: "Mon odyssée", id: 0, disabled: false, url: null, inLive: false },
			{ name: "Mes étapes", id: 1, disabled: false, url: "etapes", inLive: false },
			{ name: "Webinaires", id: 2, disabled: false, url: "webinaires", inLive: isInLive },
			{ name: "Aller plus loin", id: 3, disabled: !odyssee?.datefin, url: "aller-plus-loin", inLive: false },
		];
	}, [isMobile, odyssee, isInLive]);

	return (
		<Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
			<GradientTypo fontSize={isMobile ? "30px" : "40px"} sx={{ marginBottom: 5, marginLeft: isMobile ? 5 : 0 }}>
				{odyssee?.titre}
			</GradientTypo>
			<MenuOdyssee
				ref={menuRef}
				elements={menuElement}
				onClick={({ index }) => {
					setCurrentPage(index);
				}}
			/>
			{currentPage !== 2 && currentPage !== 1 && (<OdysseeCommunityStat odysseeId={odyssee?.id} />)}
			{currentPage === 0 && (
				<motion.div
					style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
					exit={{ opacity: 0 }}
					transition={{ type: "spring", duration: 1 }}
					initial={{ opacity: 0, scale: 0.95 }}
					animate={{ opacity: 1, scale: 1 }}
				>
					<Home setCurrentPage={(index) => menuRef?.current?.navigate(index)} />
				</motion.div>
			)}
			{currentPage === 1 && <Summary />}
			{currentPage === 2 && <Community />}
			{currentPage === 3 && <GoFurther goFurther={goFurther} />}
		</Box>
	);
};

export default OdysseeHome;
